import React from "react";
import {UserContext} from "@web/hooks/context";
import VoiceCallButton from "./VoiceCallButton";
import {useSelector} from "react-redux";
import {Link} from "wouter";
import PropTypes from "prop-types";

Hotline.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};

function Hotline(props) {
  const [userId, h] = React.useContext(UserContext);
  const assistantPath = ["user", userId, "lines", "assistant"].join("/");
  const assistantName = useSelector((state) => state.Lines?.data?.[assistantPath]?.assistantName);
  if (!h) {
    return <span className="font-lg">
      <Link to="/claim" className="text-color bolded">Call assistant</Link>
    </span>;
  }
  return <div className="space space-center-y">
    <VoiceCallButton hideIcon size="small" to={h} text={props.text || `Call ${assistantName || "Assistant"}`} />
  </div>
}

export default Hotline;
